export default __webpack_public_path__ + "static/media/SEG-Education-eLearning.da3e1815.png";